import React, { FC } from "react";
import { WidthContainer } from "kw/util/ChatFlow";
import { ExpirationInput as ExpInput } from "kanopi-components/Input/ExpirationInput";
import { FormControl } from "kanopi-components/Input/FormControl";
import { FormControlProps } from "baseui/form-control";

export const ExpirationInput: FC<FormControlProps> = ({
  label,
  title,
  help,
  error,
  hideLabel,
  ...props
}) => {
  return (
    <WidthContainer>
      <FormControl
        label={label}
        title={title}
        caption={help}
        error={error}
        hideLabel={hideLabel}
      >
        <ExpInput {...props} />
      </FormControl>
    </WidthContainer>
  );
};
